<script setup lang="ts">
import Dragger from "./Dragger.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import CloseContourBtn from "./options/CloseContourBtn.vue";
import KeypadToggleBtn from "./options/KeypadToggleBtn.vue";
import DisableToolBtn from "./options/DisableToolBtn.vue";
import Settings from "@/stores/Settings";
</script>

<template>
  <ToolOptionsDropdown :owners="[DraggerType.Polyline]">
    <template #tool>
      <Dragger
        :config="{ name: DraggerType.Polyline }"
        phosphor-icon="polygon"
        :tooltip-title="$t('canvas:tools.polyline.tooltip.title')"
        :tooltip-text="$t('canvas:tools.polyline.tooltip.text')"
        @click="
          DraggerMenuState.setActiveDragger({ name: DraggerType.Polyline })
        "
      />
    </template>
    <div
      class="btn-group-vertical rounded p-1"
      style="background-color: var(--canvas-bg)"
    >
      <DisableToolBtn v-if="!Settings.onlyStylusOn" />
      <CloseContourBtn />
      <KeypadToggleBtn />
    </div>
  </ToolOptionsDropdown>
</template>
